import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, MessageCircle, LogOut } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { settingsAPI, authAPI } from '../services/api';

export default function ExpiredAccess() {
  const [settings, setSettings] = useState({
    whatsapp_number: '',
    whatsapp_message: 'Saya ingin memperpanjang akses NUTRIMUS saya.'
  });
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    loadSettings();
    loadUserInfo();
  }, []);

  const loadSettings = async () => {
    try {
      const data = await settingsAPI.getPublicSettings();
      setSettings(data);
    } catch (err) {
      console.error('Error loading settings:', err);
    }
  };

  const loadUserInfo = () => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      setUser(JSON.parse(userStr));
    }
  };

  const handleContactAdmin = () => {
    if (settings.whatsapp_number) {
      const message = encodeURIComponent(settings.whatsapp_message);
      const waUrl = `https://wa.me/${settings.whatsapp_number}?text=${message}`;
      window.open(waUrl, '_blank');
    } else {
      alert('Nomor WhatsApp belum dikonfigurasi. Silakan hubungi administrator.');
    }
  };

  const handleLogout = () => {
    authAPI.logout();
    navigate('/');
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <Card className="max-w-md w-full shadow-xl">
        <CardContent className="pt-8 pb-8 px-6 text-center space-y-6">
          {/* Lock Icon */}
          <div className="flex justify-center">
            <div className="bg-red-100 p-4 rounded-full">
              <Lock className="h-12 w-12 text-red-600" />
            </div>
          </div>

          {/* Heading */}
          <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Masa Akses Anda Telah Habis
            </h1>
            <p className="text-gray-600">
              Akses Anda ke aplikasi NUTRIMUS telah berakhir
            </p>
          </div>

          {/* User Info */}
          {user && (
            <div className="bg-gray-50 rounded-lg p-4 space-y-2 text-left">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Nama:</span>
                <span className="font-medium text-gray-900">{user.name}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Email:</span>
                <span className="font-medium text-gray-900">{user.email}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Tipe Paket:</span>
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                  user.role === 'trial' 
                    ? 'bg-orange-100 text-orange-800 border border-orange-300'
                    : 'bg-blue-100 text-blue-800 border border-blue-300'
                }`}>
                  {user.role === 'trial' ? 'Trial' : 'User'}
                </span>
              </div>
              {user.access_expired_date && (
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Berakhir pada:</span>
                  <span className="font-medium text-red-600">
                    {formatDate(user.access_expired_date)}
                  </span>
                </div>
              )}
            </div>
          )}

          {/* Message */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm text-blue-800">
            <p>
              Untuk melanjutkan menggunakan NUTRIMUS, silakan hubungi administrator 
              untuk memperpanjang akses Anda.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="space-y-3">
            <Button
              onClick={handleContactAdmin}
              className="w-full bg-green-600 hover:bg-green-700 text-white"
              size="lg"
            >
              <MessageCircle className="h-5 w-5 mr-2" />
              Hubungi Admin via WhatsApp
            </Button>

            <Button
              onClick={handleLogout}
              variant="outline"
              className="w-full"
              size="lg"
            >
              <LogOut className="h-5 w-5 mr-2" />
              Logout
            </Button>
          </div>

          {/* Footer Note */}
          <div className="text-xs text-gray-500 pt-2">
            Jika Anda merasa ini adalah kesalahan, silakan hubungi administrator.
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
